import { getRecurrenceDefinitions, type RecurrenceDefinitionRow } from '../endpoints/getRecurrenceDefinitions';

/**
 * Load a single definition by id via the list endpoint (the backend exposes
 * lookup-by-id only as a filtered list). Returns the list row.
 */
export const loadRecurrenceDefinitionById = async (recurrenceDefinitionId: number): Promise<RecurrenceDefinitionRow> => {
  const { nodes } = await getRecurrenceDefinitions({ recurrence_definition_id: recurrenceDefinitionId, limit: 1 });
  const node = nodes[0];
  if (!node) {
    throw new Error(`Recurrence definition ${recurrenceDefinitionId} could not be loaded.`);
  }
  return node;
};
